import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

// 진행 중 (active) 경매 입찰자 list — 출품자 전용 read-only
// 출품자가 즉시 마감 결정 (computeUnifiedTop5 helper 재사용)
// 2026-05-10 — Kyle 의도: "어떤 바이어가 얼마에 입찰했는지 알아야 마감 결정"
function ActiveBiddersList(props){
  var auctionId=props.auctionId;
  var refreshKey=props.refreshKey; // 외부 socket event 시 부모가 trigger

  var[bidders,setBidders]=useState([]);
  var[meta,setMeta]=useState(null);
  var[loading,setLoading]=useState(true);
  var[error,setError]=useState('');

  useEffect(function(){
    if(!auctionId)return;
    setLoading(true);
    setError('');
    authFetch(API+'/auctions/'+auctionId+'/active-bidders')
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success&&d.data){
          setBidders(d.data.bidders||[]);
          setMeta({totalBids:d.data.totalBids,endsAt:d.data.endsAt});
        }else{
          // 권한/상태 fail 은 silent — UI 에 영향 없도록 (출품자 아니면 hide)
          if(d&&d.code==='NOT_SELLER')return;
          setError((d&&d.error)||'입찰자 조회 실패');
        }
      })
      .catch(function(){setError('서버 연결 실패')})
      .then(function(){setLoading(false)});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[auctionId,refreshKey]);

  if(loading){
    return <div style={{padding:14,fontSize:12,color:'#94a3b8',textAlign:'center'}}>입찰자 조회 중...</div>;
  }
  if(error){
    return <div style={{padding:'10px 12px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:8,fontSize:12,color:'#dc2626'}}>⚠ {error}</div>;
  }
  if(bidders.length===0){
    return (
      <div style={{padding:'24px 14px',textAlign:'center',background:'#f8fafc',borderRadius:8,color:'#94a3b8',fontSize:12}}>
        <div style={{fontSize:28,marginBottom:6,opacity:0.5}}>🔨</div>
        <div>아직 입찰이 없습니다</div>
      </div>
    );
  }

  return (
    <div style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:8,overflow:'hidden'}}>
      {/* 헤더 */}
      <div style={{padding:'10px 14px',background:'#f8fafc',borderBottom:'1px solid #e5e7eb',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div style={{fontSize:13,fontWeight:700,color:'#1B3A5C'}}>
          🔨 입찰자 ({bidders.length}건{meta&&meta.totalBids>bidders.length?' / 전체 '+meta.totalBids:''})
        </div>
        <div style={{fontSize:10,color:'#94a3b8'}}>마감 전 즉시 마감 결정용</div>
      </div>
      {/* 입찰 list */}
      {bidders.map(function(b,i){
        var isExternal=b.bidType==='external';
        var bidderLabel=isExternal
          ?(b.buyerName||'외부바이어')+(b.buyerCountry?' ('+b.buyerCountry+')':'')
          :(b.bidderName||'내부입찰')+(b.companyName?' / '+b.companyName:'');
        // mysql DECIMAL → string 대응 (Number 강제)
        var trustText=isExternal
          ?'매너 '+Number(b.trustTemp||36.5).toFixed(1)+'°'
          :(b.trustLevel||'').toUpperCase()+(b.avgScore?' ★'+Number(b.avgScore).toFixed(1):'');
        return (
          <div key={(b.bidType||'i')+'-'+b.bidId} style={{padding:'12px 14px',borderTop:i>0?'1px solid #f1f5f9':'none',display:'flex',alignItems:'center',gap:10}}>
            {/* rank */}
            <div style={{width:24,height:24,borderRadius:'50%',background:b.rank===1?'#fef3c7':'#f1f5f9',color:b.rank===1?'#92400e':'#475569',fontSize:11,fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>{b.rank}</div>
            {/* bidder + trust */}
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:13,fontWeight:700,color:'#0f172a',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                {bidderLabel}
                <span style={{marginLeft:6,padding:'1px 6px',background:isExternal?'#dbeafe':'#e0e7ff',color:isExternal?'#1e40af':'#3730a3',borderRadius:3,fontSize:9,fontWeight:700}}>
                  {isExternal?'외부':'내부'}
                </span>
              </div>
              <div style={{fontSize:11,color:'#64748b',marginTop:2}}>{trustText}{b.totalBuys?' · 거래 '+b.totalBuys:''}{b.cancelledCount?' · 취소 '+b.cancelledCount:''}</div>
            </div>
            {/* amount */}
            <div style={{fontSize:14,fontWeight:800,color:'#1B3A5C',fontVariantNumeric:'tabular-nums'}}>
              {(b.amount/10000).toLocaleString()}<span style={{fontSize:10,fontWeight:600,color:'#64748b',marginLeft:2}}>만원</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ActiveBiddersList;
